import { ForwardedRef, useCallback, useImperativeHandle, useState } from "react";
import { ModalControllerProps, ModalRef } from "./types";

export function useModalController(
  ref: ForwardedRef<ModalRef>,
  {
    mutate,
    reset,
    onClose,
    onOpen
  }: ModalControllerProps
  ) {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState<string | null>(null);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    reset?.({});
    onClose?.();
  }, [reset, onClose]);

  const handleConfirm = useCallback((data: any) => {
    const payload = id ? { id, ...data } : data;

    mutate?.(payload, {
      onSuccess: () => handleClose(),
    });
  }, [mutate, handleClose, id]);

  useImperativeHandle(
    ref,
    () => ({
      open: (data: any) => {
        reset?.(data);
        setId(data?.id ?? null);
        setIsOpen(true);
        onOpen?.();
      },
      close: handleClose,
      getId: () => id,
      isOpen: isOpen,
    }),
    [reset, handleClose, setIsOpen, id, setId, isOpen, onOpen]
  );

  return {
    isOpen,
    handleClose,
    handleConfirm,
  };
}

